import { render, staticRenderFns } from "./ItemDePesquisa.vue?vue&type=template&id=f60d4452"
import script from "./ItemDePesquisa.vue?vue&type=script&lang=js"
export * from "./ItemDePesquisa.vue?vue&type=script&lang=js"
import style0 from "./ItemDePesquisa.vue?vue&type=style&index=0&id=f60d4452&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports